import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from './pages/Index.vue';
Vue.use(VueRouter);

export function createRouter() {
  return new VueRouter({
    mode: 'hash',
    scrollBehavior() {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 0);
      });
    },
    routes: [
      {
        name: 'index',
        path: '/',
        // component: () => import(/* webpackChunkName: 'index' */ './pages/Index.vue')
        component: Index
      }
    ]
  });
}
